import styled from 'styled-components';
import { mediaq } from '~/themes/style-utils-v2';
import { newColors } from '~/themes/variables';
/* DonationSummaryCard Container */
export const DonationSummaryCardContainer = styled.div `
  width: 100%;
  padding: 36px 36px 36px 18px;
  border-bottom: 1px solid ${newColors.gray100dot30};

  ${mediaq.sm `
    padding: 24px;
  `}
`;
export const DonationSummaryCardOuter = styled.div `
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
export const DonationSummaryCardInner = styled.div `
  display: flex;
  align-items: flex-start;
  gap: 36px;
  width: 100%;

  ${mediaq.sm `
    gap: 18px;
  `}
`;
export const DonationSummaryCardDetails = styled.div `
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;

  ${mediaq.sm `
    gap: 2px;
  `}
`;
export const DonationSummaryCardHeader = styled.div `
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
export const DonationSummaryCardDonator = styled.span `
  color: #121a45;
  font-size: 16px;
  font-weight: 400;

  ${mediaq.sm `
    font-size: 14px;
  `}
`;
export const DonationSummaryCardAmount = styled.span `
  color: #68597a;
  font-size: 16px;
  font-weight: 500;

  ${mediaq.sm `
    font-size: 14px;
  `}
`;
export const DonationSummaryCardTime = styled.span `
  color: #71768f;
  font-size: 12px;
  font-weight: 400;
`;
export const DonationSummaryCardDescription = styled.div `
  display: ${(props) => (props.isMobile ? 'none' : 'block')};
  color: #6d6473;
  font-size: 14px;
  font-weight: 400;
  margin: 0;

  ${mediaq.sm `
    display: ${(props) => (props.isMobile ? 'block' : 'none')};
  `}
`;
